import { render, staticRenderFns } from "./delail.vue?vue&type=template&id=bc5c86a4"
import script from "./delail.vue?vue&type=script&lang=js"
export * from "./delail.vue?vue&type=script&lang=js"
import style0 from "./delail.vue?vue&type=style&index=0&id=bc5c86a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports